// libs
import { Dispatch } from "react";

// defs
import { IAction } from "@defs/Action";
import { IAppState, initialPageAlertState, IPageAlertState, IPageTitleState } from "@store/state/App";
import { Stage } from "@helpers/index";

// Action types for app-related state
export enum AppActionTypes {
    SET_START_LOADING = "SET_START_LOADING",
    SET_STOP_LOADING = "SET_STOP_LOADING",
    SHOW_ALERT_MESSAGE = "SHOW_ALERT_MESSAGE",
    HIDE_ALERT_MESSAGE = "HIDE_ALERT_MESSAGE",
    SET_PAGE_TITLE = "SET_PAGE_TITLE",
    SET_SIDE_MENU_OPEN = "SET_SIDE_MENU_OPEN",
    SET_SIDE_MENU_CLOSE = "SET_SIDE_MENU_CLOSE",
    TOGGLE_MENU_CLOSE = "TOGGLE_MENU_CLOSE",
    SET_STAGE = "SET_STAGE",
}

// Action to start loading state
export const startLoading = (dispatch: Dispatch<IAppAction>) => {
    return () => {
        dispatch({
            type: AppActionTypes.SET_START_LOADING,
            payload: { isLoading: true },
        });
    };
};

// Action to stop loading state
export const stopLoading = (dispatch: Dispatch<IAppAction>) => {
    return () => {
        dispatch({
            type: AppActionTypes.SET_STOP_LOADING,
            payload: { isLoading: false },
        });
    };
};

// Action to show alert message
export const showAlertMessage = (dispatch: Dispatch<IAppAction>) => {
    return (pageAlert: IPageAlertState) => {
        dispatch({
            type: AppActionTypes.SHOW_ALERT_MESSAGE,
            payload: { pageAlert },
        });
    };
};
// Action to hide alert message
export const hideAlertMessage = (dispatch: Dispatch<IAppAction>) => {
    return () => {
        dispatch({
            type: AppActionTypes.HIDE_ALERT_MESSAGE,
            payload: { pageAlert: initialPageAlertState },
        });
    };
};

// Action to set page title
export const setPageTitle = (dispatch: Dispatch<IAppAction>) => {
    return (pageTitle: IPageTitleState) => {
        dispatch({
            type: AppActionTypes.SET_PAGE_TITLE,
            payload: { pageTitle },
        });
    };
};

// Action to set side menu open state
export const openSideMenu = (dispatch: Dispatch<IAppAction>) => {
    return () => {
        dispatch({
            type: AppActionTypes.SET_SIDE_MENU_OPEN,
            payload: { isSideMenuOpen: true },
        });
    };
};

// Action to set side menu open state
export const closeSideMenu = (dispatch: Dispatch<IAppAction>) => {
    return () => {
        dispatch({
            type: AppActionTypes.SET_SIDE_MENU_CLOSE,
            payload: { isSideMenuOpen: false },
        });
    };
};

// Action to toggle menu open state
export const toggleSideMenu = (dispatch: Dispatch<IAppAction>) => {
    return () => {
        dispatch({
            type: AppActionTypes.TOGGLE_MENU_CLOSE,
            payload: {},
        });
    };
};

export const setStage = (dispatch: Dispatch<IAppAction>) => {
    return (stage: Stage) => {
        dispatch({
            type: AppActionTypes.SET_STAGE,
            payload: { stage },
        });
    };
};

// Action interfaces
export interface IAppAction extends IAction<AppActionTypes, IAppState> {}
